import "../lib";

const searchParams = new URLSearchParams(window.location.search);
const type = searchParams.get("type") || "direct";

// const apVideoHub = new window.nextologies.ApVideoHub();

window.nextologies.player.create({
    root: "ap-player-direct",
    type: "direct",
});

window.nextologies.player.create([
    {
        root: "ap-player-lc01",
        type: "lc01",
    }, {
        root: "ap-player-lc02",
        type: "lc02",
    }
]);
